import React, { useEffect, useState } from 'react';
import { get_ListeStatut } from '../api/appartenance';
import { Select } from 'antd';

const {Option} = Select


const ListeStatut = ({liste, onchange, valeur}) => {
  
    return (
        <div>
            <Select
                showSearch
                size = 'medium'
                style = {{
                    width: '100%',
                    textAlign: 'center',
                    margin: "0 auto"

                }}
                value={valeur !== undefined ? valeur : null}
                onChange={(value) => {
                    if(onchange) onchange(value)
                }}
                placeholder="Choisir une propriété"
            >
                <Option value={0}>Tous</Option>
                {
                    liste && liste.map(item => {
                        return(
                            <Option key={item['id']} value={item['id']}>{item.nom}</Option>
                        )
                    })
                }
            </Select>
        </div>
    );
}

export default ListeStatut;
